import axios from 'axios';

export default {
    state: {
    },
    mutations: {
    },
    actions: {
        async queryPost({ dispatch }, {headers, url, params}) {
            let result = null;
            await axios
              .post(`/api/${url}`, { headers }, params)
              .then((response) => {
                result = response;
              })
              .catch((error) => {
                dispatch('addError', { message: error.response.data });
              });
            return result;
        },
        async queryGet({ dispatch }, {headers, url}) {
            dispatch
            let result = null;
            await axios
              .post(url, { headers })
              .then((response) => {
                result = response;
              })
              .catch((error) => {
                result = error
              });
            return result;
        }
    },
    getters: {
    },
  };
